import { SharedService } from './../../services/shared.service';
import { Component, Input, OnInit } from '@angular/core';
import { Exhibitor, Projection } from '../../models/projection.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailModalComponent } from '../email-modal/email-modal.component';
import { FiltersService } from '../filters/filters.service';
import { UtilsService } from '../utils/utils.service';
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { DetailsService } from '../details/details.service';
import { LoginService } from '../login/login.service';
import { ExhitorsService } from '../exhitors/exhitors.service';
import { MatDialog } from '@angular/material/dialog';
import {ModalSimpleComponent} from "../modal-simple/modal-simple.component";
import {SessionService} from "../common/session/session.service";
import { AnalyticsService } from '../analytics/analytics.service';

const SOCIAL_NETWORK_KEYS = [
  'social.share.facebook',
  'social.share.twitter',
  'social.share.pinterest',
  'social.share.linkedIn',
  'social.share.whatsApp',
  'social.share.telegram'
];

@Component({
  selector: 'app-detail-actions',
  templateUrl: './detail-actions.component.html',
  styleUrls: ['./detail-actions.component.css']
})
export class DetailActionsComponent implements OnInit {

  @Input() isFavorite: boolean;
  @Input() parent: any = {};
  @Input() type: string;
  @Input() analytics: any = {};

  anonymousEmailAllowed: boolean = false;
  data: any = {};
  eventData: any;
  mobile: boolean = false;

  constructor(protected modalService: NgbModal, private filtersService:FiltersService, public utilsService:UtilsService, 
    private detailsService:DetailsService, private loginService:LoginService, private exhibitorSvc: ExhitorsService,
    public dialog: MatDialog, private sessionService: SessionService, private analyticsService: AnalyticsService, 
    private sharedService:SharedService){
  }

  ngOnInit(): void {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.anonymousEmailAllowed = this.utilsService.parseBoolean(this.detailsService.getPropertyByKey('home.view.default'));
    this.sharedService.getIsMobile().subscribe(arg => this.mobile = arg);
  }

  hasActiveSocialNetworks(): boolean {
    return SOCIAL_NETWORK_KEYS.some(key => this.detailsService.getPropertyByKey(key, true));
  }

  setFavorite() {
    this.isFavorite = !this.isFavorite;
  }

  addToFavorites(item: any) {

    let endpoint = 'Exhibitor';
    let entityId = item.id || item.idExhibitor || item.productId;

    if (this.type === 'PRODUCT') {
      endpoint = 'Product';
    }

    this.data = {};
    this.data.eventName = this.eventData['eventName'];
    this.data['id' + endpoint] = entityId;
    this.data.type = endpoint;
    this.data.note = item.note;
    this.data.sapCode = this.eventData['sapCode'];

    if (this.loginService.isAuth()) {
      this.exhibitorSvc.createFavoriteExhibitor(this.data).subscribe(res => {
        this.parent.isFavorite = true;
        this.parent.favoriteId = res.id;
        this.analyticsService.sendAddToFavorites(this.analytics, this.type.toLowerCase());
      }, err => {
        console.warn(err);
      });
    }
    else {
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
        this.exhibitorSvc.createFavoriteExhibitor(this.data).subscribe(res => {
          this.parent.isFavorite = true;
          this.parent.favoriteId = res.id;
          this.analyticsService.sendAddToFavorites(this.analytics, this.analytics.type.toLowerCase());
        });
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });
    }
  }

  deleteFromFavorites(item: any){
    let entityId = item.favoriteId || item.id;

    if (this.loginService.isAuth()) {
      (this.type === 'EXHIBITOR' || this.type === 'NOVELTIES') ? this.deleteFavoriteExhibitor(entityId): this.deleteFavoriteProduct(entityId);
    } else {
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
        (item.type === 'EXHIBITOR' || item.type === 'NOVELTIES') ? this.deleteFavoriteExhibitor(entityId): this.deleteFavoriteProduct(entityId);
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });

    }
  }

  deleteFavoriteExhibitor(entityId){
    this.exhibitorSvc.deleteFavoriteExhibitor(entityId).subscribe(res => {
      this.parent.isFavorite = false;
      this.analyticsService.sendRemoveFromFavorites(this.analytics, this.type.toLowerCase());
    }, err => {
      console.warn(err);
    });
  }

  deleteFavoriteProduct(entityId){
    this.exhibitorSvc.deleteFavoriteProduct(entityId).subscribe(res => {
      this.parent.isFavorite = false;
      this.analyticsService.sendRemoveFromFavorites(this.analytics, this.type.toLowerCase());
    }, err => {
      console.warn(err);
    });
  }

  showEmailForm() {
    if (this.loginService.isAuth()) {
      this.openEmailModal();
    } else if (this.anonymousEmailAllowed && !this.loginService.isAuth()) {
      this.openEmailModal();
    } else {
      //this.broadcaster.broadcast('displayLogin', {redirect: false});
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
        this.openEmailModal();
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });
    }
  }

  openEmailModal() {

    if (this.loginService.isAuth()) {
      this.showEmailModal();
    }
    else{
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
          this.showEmailModal();
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });
    }

  }

  
  showEmailModal() {

    const modalRef = this.modalService.open(EmailModalComponent, { size: 'lg' });
    modalRef.componentInstance.exhibitorEmail = this.parent['email'];
    modalRef.result.then(email => {
      var emailParams = {
        'to': this.parent.id,
        'name': email.name,
        'subject': email.subject,
        'text': email.text,
        'from': email.from,
        'captchaResponse': email.captchaResponse
      };
      this.filtersService.sendExpositorByVisitor(emailParams).subscribe(result => {
        console.log('successfully_sent');
        this.analyticsService.sendContact(this.parent.countryId, this.parent.zipCode);
        this.showDialog("MODAL_SIMPLE.SUCCESSFULLY_SENT");
      }, err => {
        if (err.status === 403) {
          console.log('permissionDenied');
          this.showDialog("MODAL_SIMPLE.PERMISSIONDENIED");
        } else {
          console.log('apiError000000');
          this.showDialog("MODAL_SIMPLE.APIERROR000000");
        }
        console.warn(err);
      });
    }).catch(error => {
      console.warn(error);
    });

  }

  showDialog(text:string): void {
    const modalRef = this.modalService.open(ModalSimpleComponent);
    modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
    modalRef.componentInstance.modalInformation = text;
    modalRef.componentInstance.isHtml = false;
  }

}
